import React from "react";


import { useEffect,useState } from "react";

//const images = [<img key={0} className="img2022 main_box2" src="./banner/karmozd-desk.png" alt="کارمزد صفر برای معاملات ارزهای دیجیتال"/>, <img key={0} className="img2022 main_box2" src="./banner/free-babydoge-desktop.png" alt="بیبی دوج رایگان | تتر رایگان" />, <img key={0} className="img2022 main_box2" src="./banner/free-coin-desk.png" alt="درامد آسان با دعوت دوستان | ارز په په رایگان"/>];
const images = ["./banner/karmozd-desk.png", ]

export default function SlideDesktop() {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            console.log("run ...")
            console.log(images.length)
            if(currentIndex === images.length -1) {

                setCurrentIndex(0);
            } 
            else {
                console.log("run ------...")
                console.log(currentIndex)



                let value =  currentIndex + 1
                console.log(value)

                 setCurrentIndex(value);
                 setCurrentIndex(value);

            }
        }, 5000)
        
        return () => clearInterval(intervalId);
    }, [])



    

    return (
        <a href="/prize-exchange">

        <div key={currentIndex} className="sub2022">

                <img key={currentIndex} className="img2022 main_box2" src={ images[currentIndex]} alt="کارمزد صفر برای معاملات ارزهای دیجیتال"/>

                   
        </div>
        </a>
    )
}